
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import { initData } from "./initData"

const PageConst = {
  ACTION: {
    init: { api: 'T1110StudentCurriculumService.C20201_init' },
    doSave: { api: 'T1110StudentCurriculumService.doSave' },
    getEdit: { api: 'T1110StudentCurriculumService.getEdit' },
    doRead: { api: 'T1110StudentCurriculumService.doRead' },
    doDelete: { api: 'T1110StudentCurriculumService.doDelete' },
    doBrowse: { api: 'T1110StudentCurriculumService.doBrowse' },
  },
}

const module = {
  state: {
    PageConst,
    students: [],
    centers: [],
    users: [],
    curriculumAdvisors: [],

    oldRow: null,
    leaveButtonClicked: false,
  },

  getters: {
    getDropdownList (state){
      return {
        row: {
          enrollment_status: [
            {
              label: window.vue.$i18n.t('C20201.C20201Store.UUSxfHG-PtJdw_733pS2R'),
              value: 0
            },
            {
              label: window.vue.$i18n.t('C20201.C20201Store.pRgHMTSyxKqtsfuesp3_4'),
              value: 1
            },
            {
              label: window.vue.$i18n.t('C20201.C20201Store.vkivfn2mVLBC1365wYCMN'),
              value: 2
            },
            {
              label: window.vue.$i18n.t('C20201.C20201Store.1yIEp63nzj_kq5fvv07fJ'),
              value: 3
            }
          ]
        },
        studentInfo: {
          // "性別"
          instructorGender: [
            window.vue.$i18n.t('C20201.InterviewSet.1Wq0ASUZpuzcyq9KXqnxh'),
            window.vue.$i18n.t('C20201.InterviewSet.uc1NmQgnAIebMp7I_8gfG'),
            window.vue.$i18n.t('C20201.InterviewSet.BlIzEYGvqDvfDz5AKh6Tk')
          ],
          // "保護者続柄"
          "guardianRelationship": [
            window.vue.$i18n.t('C20201.C20201Store.fYIccGNcAyX6dfbkes8SX'),
            window.vue.$i18n.t('C20201.C20201Store.6bw52_L25W8m1dN41FCvJ'),
            window.vue.$i18n.t('C20201.C20201Store.TU44ZWdojc8kvX9QXSBtM'),
            window.vue.$i18n.t('C20201.C20201Store.oX7VuFnvfxgWxZcFkhGH-'),
            window.vue.$i18n.t('C20201.C20201Store.5qKUXmxgxsuEUcB6L2QnK'),
            window.vue.$i18n.t('C20201.C20201Store.hlWQBVcyHFmvbhA--SOsl')
          ],
          // "学年（区分）"
          academicType: [
            window.vue.$i18n.t('C10101.Edit.xiao-xue'),
            window.vue.$i18n.t('C10101.Edit.zhong-xue'),
            window.vue.$i18n.t('C10101.Edit.gao-xiao'),
            window.vue.$i18n.t('C20201.C20201Store.C8DQuRyKKKoevZrSMEpfc'),
            window.vue.$i18n.t('C20201.C20201Store.b4eaY8TKbVWp8no6ZYwLF'),
            window.vue.$i18n.t('C20201.C20201Store.VhZWaAI2BuXQ_Ql29hIw6'),
            window.vue.$i18n.t('C20201.C20201Store.HpJtzRoWR1PPokqPIMCA7')
          ],
          // "学年（年生）"
          academicYear: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            window.vue.$i18n.t('C20201.C20201Store.WbKbT8IJYzuFkKs-9krNP'),
            window.vue.$i18n.t('C20201.C20201Store.kH1qN7eqRHSZrvnaijHep'),
            window.vue.$i18n.t('C20201.C20201Store.bIBVvU-jYMjaovDfh5kZq'),
            "-"
          ],
          academicYearCustom: {
            幼児: [window.vue.$i18n.t('C20201.C20201Store.zY_t9caTyw2zzN1dn3m1s'), window.vue.$i18n.t('C20201.C20201Store.HAVKuUPrVA4PrAa2_RThj'), window.vue.$i18n.t('C20201.C20201Store.gMUf_jaHiQ8GcgdVQdt2B'),],
            小学: ["1", "2", "3", "4", "5", "6"],
            中学: ["1", "2", "3",],
            高校: ["1", "2", "3",],
            大学: ["1", "2", "3", "4"],
            専門: ["1", "2", "3", "4"],
            社会人: ["-"],
          },
          // "分類"
          schoolCategory: [
            window.vue.$i18n.t('C20201.C20201Store.ACb0rgUrNrxhXDyCc0kUG'),
            window.vue.$i18n.t('C20201.C20201Store.p9wHkRvcKUNUnsmkCY64Y'),
            window.vue.$i18n.t('C20201.C20201Store.j0abLkykzpRGcdcEuAVYM'),
            window.vue.$i18n.t('C20201.C20201Store.4EVntE0c0EKP_bWT65Q46'),
            window.vue.$i18n.t('C20201.C20201Store.EKJ8g6cHbeyCiDrU6I_CV'),
            window.vue.$i18n.t('C20201.C20201Store.GHla-QA1hS1zs_tDHqxmc'),
            window.vue.$i18n.t('C20201.C20201Store.q0VQejVQrtT0oRS5O8YFt'),
            window.vue.$i18n.t('C20201.C20201Store.e7JkOnzHmZHq5-w1SJ9Mv'),
            window.vue.$i18n.t('C20201.C20201Store.UxBbKnuS4Xu02O4NZyLp5'),
            window.vue.$i18n.t('C10101.Edit.sono'),
          ],
          // "学期制"
          semester: [
            window.vue.$i18n.t('C20201.C20201Store.yFGCtvFkbx-NlDyjYtvZ9'),
            window.vue.$i18n.t('C20201.C20201Store.2CmoUdQaGa5nsJysKzQMX'),
            "-",
            window.vue.$i18n.t('C20201.C20201Store.Czc7azqphKnHL6Bz1S-yg')
          ],
          // "住所"
          address1: [
            window.vue.$i18n.t('C20201.C20201Store.PpTgrsOI0NlwLS9OT7yBJ'),
            window.vue.$i18n.t('C20201.C20201Store.kZZsHg6BdfVWmP4h9mJW_'),
            window.vue.$i18n.t('C20201.C20201Store.sk7pxoiJo3MJ0AZMrJXEB'),
            window.vue.$i18n.t('C20201.C20201Store.7KfOfgeY6hogRZyj4-vCd'),
            window.vue.$i18n.t('C20201.C20201Store.tZxV5XYyCx9lhxNg-QdVA'),
            window.vue.$i18n.t('C20201.C20201Store.2IxDU1AW_BZ4kvsFXU2Ym'),
            window.vue.$i18n.t('C20201.C20201Store.GrmGoHujW1PML7KRBVGw7'),
            window.vue.$i18n.t('C20201.C20201Store.uNeYMTzCGrLIuXPsGtyjv'),
            window.vue.$i18n.t('C20201.C20201Store.R5w3RXuXIvjnaUGjxEz2l'),
            window.vue.$i18n.t('C20201.C20201Store.vghruFV3fQj7tdfQWiCpr'),
            window.vue.$i18n.t('C20201.C20201Store.z04gUBem7SrBWOGybbYcy'),
            window.vue.$i18n.t('C20201.C20201Store.61EfuZcY0rXdsy-Yti2xY'),
            window.vue.$i18n.t('C20201.C20201Store._4tvhT-mGbv0_eZlurX8P'),
            window.vue.$i18n.t('C20201.C20201Store.MOyO0OcjPjuckb3PXvEU2'),
            window.vue.$i18n.t('C20201.C20201Store.WsYtGlv6gOEHikvNrgP7W'),
            window.vue.$i18n.t('C20201.C20201Store.6zMGB37GkANJ9Cg5W1oZ6'),
            window.vue.$i18n.t('C20201.C20201Store.y_u62j3E1RWZfTcR1EfDz'),
            window.vue.$i18n.t('C20201.C20201Store.jTOW5NriuwpHLnCVA1r0o'),
            window.vue.$i18n.t('C20201.C20201Store.YrtKW75cxbfOhBOr0CxJh'),
            window.vue.$i18n.t('C20201.C20201Store.tYR8WakAasqRJcS2DXvuX'),
            window.vue.$i18n.t('C20201.C20201Store.pNH4cJi--cjahqr_WrrXt'),
            window.vue.$i18n.t('C20201.C20201Store.EB1679qhquEE8K5HFBj2R'),
            window.vue.$i18n.t('C20201.C20201Store.afcPtGPV30S9ZiCT12A_V'),
            window.vue.$i18n.t('C20201.C20201Store.kVCkQT9S45sMFoWloEARl'),
            window.vue.$i18n.t('C20201.C20201Store._Ur5eXF01GMG5UGj9WkHT'),
            window.vue.$i18n.t('C20201.C20201Store.wBV72pdXCs1OLETfvoMku'),
            window.vue.$i18n.t('C20201.C20201Store.uAFnA4StC9Z_HXRiv3WdB'),
            window.vue.$i18n.t('C20201.C20201Store.wmEMWLSBWY9wMrrWf0JlH'),
            window.vue.$i18n.t('C20201.C20201Store.YJtgiPqaxzEI20iJU52NH'),
            window.vue.$i18n.t('C20201.C20201Store.5ZnYGqr2L335Y8v-0-Oqk'),
            window.vue.$i18n.t('C20201.C20201Store.5yC8saym0sNXX4iq2keMz'),
            window.vue.$i18n.t('C20201.C20201Store.imBmxHhLkqXN7NrKx0Qdc'),
            window.vue.$i18n.t('C20201.C20201Store.LTXcHTb9v8-tuDru3S8Cv'),
            window.vue.$i18n.t('C20201.C20201Store.U6TITZYLsvmi2Bb46TZGt'),
            window.vue.$i18n.t('C20201.C20201Store.W14YuK6QaOELEf7-dewTQ'),
            window.vue.$i18n.t('C20201.C20201Store.JEB9sYJGlXxMycpVXteUr'),
            window.vue.$i18n.t('C20201.C20201Store.MNfJ4MfgWtxcMD9viGgEG'),
            window.vue.$i18n.t('C20201.C20201Store.WDcS-n1a-uLDTDP0_tdVD'),
            window.vue.$i18n.t('C20201.C20201Store.4I2ihGOLagO3ZtVrBnIox'),
            window.vue.$i18n.t('C20201.C20201Store.4BO6YAzy0uyYPTUzApnU4'),
            window.vue.$i18n.t('C20201.C20201Store.5WTTjNgPvtqTxyHlh8CrA'),
            window.vue.$i18n.t('C20201.C20201Store.vhxibGkwU4WaPoGHklcZh'),
            window.vue.$i18n.t('C20201.C20201Store.0003eDfMxiA7TPqNOBO4Z'),
            window.vue.$i18n.t('C20201.C20201Store.lwbYmxFe34T979_RSWsRq'),
            window.vue.$i18n.t('C20201.C20201Store._5jIliR_NKdXaPio8qL_2'),
            window.vue.$i18n.t('C20201.C20201Store.ZgdRK5FE4W5M--vdGuoxH'),
            window.vue.$i18n.t('C20201.C20201Store.e_Wa0YVsZoun5H5H0HQ2s')
          ],
          // "営業担当"
          salesRepresentativeName: [
            window.vue.$i18n.t('C20201.C20201Store.UHANaSc7qbkUdjQc4Fj1y'),
            window.vue.$i18n.t('C20201.C20201Store.2AwDGcopeivI2Nol7VGVX'),
            window.vue.$i18n.t('C20201.C20201Store.5UX9pOBRAeZJGNkhocNMx'),
            window.vue.$i18n.t('C20201.C20201Store.fWQo8eg4pZGs9RKNthmLM'),
            window.vue.$i18n.t('C20201.C20201Store.R8H4ww6Y5Eg_FnbQUoqVP')
          ]
        },
        background: {
          // 入会を決定した方
          whoDecideToJoin: [
            window.vue.$i18n.t('C20201.C20201Store.U3Inh8yrN_HCP-3v2PUcL'),
            window.vue.$i18n.t('C20201.C20201Store.a0UKlTv0lfCiUnjGyRsqH'),
            window.vue.$i18n.t('C20201.C20201Store.nAWpAu-NqjjU9_NbveypA'),
            window.vue.$i18n.t('C20201.C20201Store.oPO_PJtlVqRc-76LO6fp5'),
            window.vue.$i18n.t('C20201.C20201Store.ach3EfEBEebGJvjZJiCY8'),
            window.vue.$i18n.t('C20201.C20201Store.9f2Fek44F-3CL_y7MarwG'),
            window.vue.$i18n.t('C20201.C20201Store.FT9bIDuLF5T85fluZLJFR'),
          ]
        },
        rowExperienceParticipants: {
          participant: [
            window.vue.$i18n.t('C20201.C20201Store.nftZeyWG9XGgTc3ecXcGp'),
            window.vue.$i18n.t('C20201.C20201Store.YELGj6lYAK9vGeckhXSqn'),
            window.vue.$i18n.t('C20201.C20201Store.OjLu-6n8ErMlxCUFsLCgj'),
            window.vue.$i18n.t('C20201.C20201Store.p5fEwInnYxbwuM8Pp6TV-'),
            window.vue.$i18n.t('C20201.C20201Store.cyVUxSVjDvl26Tid2-NSx'),
            window.vue.$i18n.t('C20201.C20201Store.IxHZ5tyu4Aba--o6rM3US'),
            window.vue.$i18n.t('C20201.C20201Store.LtdvPKUN-IiP_uskSxHUr'),
          ]
        },
        registrationInfo: {
          // "受講時間"
          courseInfo1: [
            window.vue.$i18n.t('C20201.C20201Store.ex2ZFY7nQcM1GNdU6WK0j'),
            window.vue.$i18n.t('C20201.C20201Store.Aoo8GlCZpvjLu4vowrr0I'),
            window.vue.$i18n.t('C20201.C20201Store.j-U5Gzlqj_W_ZHLaVt9hA')
          ],
          // "スタイル"
          courseInfo2: [
            window.vue.$i18n.t('C20201.C20201Store.mFmSs80jz7lZi5B8h9mON'),
            window.vue.$i18n.t('C20201.C20201Store.1LqJ2BnK4jf140Hr-a4lo')
          ],
          // "ﾍﾞｰｼｯｸ/ｱﾄﾞﾊﾞﾝｽ"
          courseInfo3: [
            "",
            window.vue.$i18n.t('C20201.C20201Store.vF_mB1FXQFuaReXXd0Pch'),
            window.vue.$i18n.t('C20201.C20201Store.sFLqSGvLHkzpK2bi7QGgu'),
            window.vue.$i18n.t('C20201.C20201Store.50ChZwGEM9zWOyD01ipAL'),
            window.vue.$i18n.t('C20201.C20201Store.xqSOsY6v0PnkOBuCf5e8B')
          ],
          // "コース"
          courseInfo4: [
            window.vue.$i18n.t('C20201.C20201Store.yFIB_fJbf3r21zOlXSePu'),
            window.vue.$i18n.t('C20201.C20201Store.Onh0uhM24tl1Gdpm90N8Y'),
            window.vue.$i18n.t('C20201.C20201Store.CIOIoXHNTVpxHQraTzrSH')
          ],
          // "開始時間"
          startTime: [
            "14:50",
            window.vue.$i18n.t('C20201.C20201Store.1YlSWalax1irAH87G_XH9'),
            "16:40",
            window.vue.$i18n.t('C20201.C20201Store.2Xl7CVwOwcpFFtRTYHsrg'),
            "18:20",
            window.vue.$i18n.t('C20201.C20201Store.qR3llFVsgAExYwe0rr_ZF'),
            "20:00",
            window.vue.$i18n.t('C20201.C20201Store.UkAkm-5uCrz0llBcdOrKS'),
            window.vue.$i18n.t('C20201.C20201Store.pShrIt-7zpBlVpwpfyydv'),
            window.vue.$i18n.t('C20201.C20201Store.ZThSAlU7Pily59ssCdRzK'),
            window.vue.$i18n.t('C20201.C20201Store.ukeZCqowKVDCJMcAKRz6z'),
            window.vue.$i18n.t('C20201.C20201Store.qQfdc03bY9Pkk0jVzI16U'),
            window.vue.$i18n.t('C20201.C20201Store.uvP-Phja3s8q1mt8fH66i'),
            window.vue.$i18n.t('C20201.C20201Store.fzrgh8U-KbwX3ePeZHXXr'),
            window.vue.$i18n.t('C20201.C20201Store.HOdsgO8RUCqc5WkHbT0Md'),
            window.vue.$i18n.t('C20201.C20201Store.YS70zS_Z1We20fj2QxlJI'),
            window.vue.$i18n.t('C20201.C20201Store.ADBTzJ-ZRclLS7wv_4mWf')
          ],
        },
        interestSchoolInfo: {
          classification: [
            window.vue.$i18n.t('C20201.C20201Store.5iLP57AfhQrVKjhIQWdn0'),
            window.vue.$i18n.t('C20201.C20201Store.OaRFyQGNHAe4dUFWxX7Ep'),
            window.vue.$i18n.t('C20201.C20201Store.yY6zRTBfU4uYmoHKqSWAv'),
            window.vue.$i18n.t('C20201.C20201Store.mYpGzfBy4fzHkI8bIxqIv'),
            window.vue.$i18n.t('C20201.C20201Store.UrDmvpYoYyTNl4YjlgYiF'),
            window.vue.$i18n.t('C20201.C20201Store.ej-YJzI0rsByh0biFDsmL'),
            window.vue.$i18n.t('C20201.C20201Store.26lFQKnOLCBj21J25KJZQ'),
            window.vue.$i18n.t('C20201.C20201Store.gx7VvL3t7--PJsRALEBya'),
            window.vue.$i18n.t('C20201.C20201Store.IAoOJaP0VTxOC2cjasQa6'),
            window.vue.$i18n.t('C10101.Edit.sono'),
          ],
          desire: [
            window.vue.$i18n.t('C20201.C20201Store.4G-ZLr3vIj0LAV6QYf2fR'),
            window.vue.$i18n.t('C20201.C20201Store.uyt0vGwjSvkOPkKwMzO0u'),
            window.vue.$i18n.t('C20201.C20201Store.wE-m0n5l7LDzXwpFT_Z68'),
          ]
        },
        lessonEnvironment: {
          // "使用機材"
          equipment: [
            "iPad",
            window.vue.$i18n.t('C20201.C20201Store.TcKsLh0HKBthY6MmnAbKZ'),
            window.vue.$i18n.t('C20201.C20201Store.XDaAYewONy4vwjL-kWHlN'),
            window.vue.$i18n.t('C20201.C20201Store.hML_d2VaEPki1deHWU4dA'),
            window.vue.$i18n.t('C20201.C20201Store.6Ay1Fhr7Z1Cummj9B4o2s'),
            window.vue.$i18n.t('C20201.C20201Store.0G8raPEkTjWZro0-tIdDW')
          ],
        },
        subject: {
          textbooks: {
            // "所有状況"
            status: [
              window.vue.$i18n.t('C20201.C20201Store.7Rfdp9DCk--p01bLhXPdh'),
              window.vue.$i18n.t('C20201.C20201Store.fAdYFXeOw-lE9bjaUhxhM')
            ]
          }
        },
        [window.vue.$i18n.t('C20201.C20201Store.jJ2FHU4OJ8jo0B8ZXk9Bd')]: [
          window.vue.$i18n.t('C20201.C20201Store.QZBvYXsgTddhOh7H5xwqC'),
          window.vue.$i18n.t('C20201.C20201Store.P0vj4s4Rgpu14iuOlOrzC')
        ],
        [window.vue.$i18n.t('C20201.C20201Store.FVuby0Br-aLnfzgi6rC8c')]: [
          window.vue.$i18n.t('C10101.Edit.xiao-xue'),
          window.vue.$i18n.t('C10101.Edit.zhong-xue'),
          window.vue.$i18n.t('C10101.Edit.gao-xiao')
        ]
      }
    }
  },

  mutations: {
  },
  actions: {
    init({ commit, state }, payload) {
      $this.$api.postData({
        data: [{ api: PageConst.ACTION.init.api, input: payload }]
      }).then((res) => {
        const data = res[0].output;
        commit('setState', {
          students: data.students,
          centers: data.centers,
          users: data.users,
          curriculumAdvisors: data.curriculumAdvisors
        })
      })
    },
    doSave({ commit, state, dispatch }, payload) {
      $this.$api.postData({
        data: [{ api: PageConst.ACTION.doSave.api, input: payload }]
      }).then(async (res) => {
        await dispatch('getEdit', res[0].output.id);
      })
    },
    async getAdd({ commit, state }, payload) {
      const data = await $this.$api.postData({
        data: {
          defaultReferenceDate: { api: 'T1130StudentSeminarService.getDefaultReferenceDate', input: {} }
        }
      })
      const dt = data.defaultReferenceDate.output;
      const defaultData = ObjArrUtils.merge({}, initData, {
        row: {
          reference_start_date: dt.reference_start_date,
          reference_end_date: dt.reference_end_date
        }
      });
      commit('SET_ROW', defaultData);
      commit('setState', {
        oldRow: defaultData,
        _removeReactivity: true,
      })
    },
    async getEdit({ commit, state, dispatch }, payload) {
      const data = await $this.$api.postData({
        data: [{
          api: PageConst.ACTION.getEdit.api,
          input: { id: payload }
        }]
      }).catch(e => {
        console.error('getEdit error', e)
      })
      const dt = data[0].output;
      await dispatch('init', {
        with_student_no: dt.student_no ?? undefined
      });
      const row = JSON.parse(dt.json_text);
      delete dt.json_text;
      row.row = dt;
      const rtnRow = ObjArrUtils.merge(initData, row);
      commit('SET_ROW', rtnRow);
      commit('setState', {
        _removeReactivity: true,
        oldRow: rtnRow
      });
    },
    async getT1130Count({ state }, studentNo) {
      return await $this.$api.postData({
        data: [
          {
            api: 'T1130StudentSeminarService.getT1130Count',
            input: { student_no: studentNo ?? 0 }
          },
        ]
      }).then(res => res[0].output)
    }

  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
